import { atom } from "jotai";

export const questionAtom = atom({ question: "", index: 0, sessionId: 0 });